import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=70c39724&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c39724')) {
      api.createRecord('70c39724', component.options)
    } else {
      api.reload('70c39724', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=70c39724&", function () {
      api.rerender('70c39724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gHJK6fe5quJ3/JS/offershelp.vue"
export default component.exports